import React from 'react';
import { IconBase } from '../Base';
export const IconLogout = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("g", { fill: "none", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", style: { stroke: 'var(--icon-color)' } },
            React.createElement("path", { d: "M12.5 10H17.6667M17.6667 10L15.1667 7.5M17.6667 10L15.1667 12.5" }),
            React.createElement("path", { d: "M3 5.53656C3 4.63045 3.60917 3.83756 4.48467 3.60409L7.98467 2.67075C9.25437 2.33217 10.5 3.28916 10.5 4.60322V15.3968C10.5 16.7108 9.25437 17.6678 7.98467 17.3292L4.48468 16.3959C3.60917 16.1624 3 15.3695 3 14.4634V5.53656Z" })),
        React.createElement("circle", { cx: "7.5", cy: "10", r: "1.25", style: { fill: 'var(--icon-color)' } })));
};
//# sourceMappingURL=Logout.js.map